import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import store from "@/store";
import router from "@/router";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import usePagination from "@/views/components/pagination/usePagination";
import { fufillmentDetailModel } from "@/models/fulfillment/fulfillment-detail";
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import { fulfillmentImportCSVModel } from "@/models/fulfillment/fulfillment-import-csv";
export default function useFulfillmentImportFile() {
  const STATUS_SUCCESS = 0;
  const STATUS_ERROR = 1;
  const { ImportCSV } = fulfillmentImportCSVModel();
  const vm = getCurrentInstance().proxy;
  const { fetchTableFulfillmentImportTrackingNoList } = fufillmentDetailModel();

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal();

  const loading = reactive({
    tableData: false,
    form: false,
  });

  const formStatus = reactive({
    validFrom: null,
    validThrough: null,
    status: null,
  });

  const statusOption = ref([
    { label: "Success", value: STATUS_SUCCESS },
    { label: "Error", value: STATUS_ERROR },
  ]);

  const fields = [
    { key: "seq", label: "No." },
    { key: "bloburl", label: "Url Upload" },
    { key: "name", label: "Upload By" },
    { key: "createdtime", label: "Created Time" },
    { key: "updatedtime", label: "Updated Time" },
    { key: "reference", label: "Reference" },
    { key: "total_trackingno", label: "Total TrackingNo" },
    { key: "total_success", label: "Total Success" },
    { key: "total_error", label: "Total Error" },
    { key: "transaction_statusdesc", label: "Status" },
    { key: "actions", label: "" },
  ];

  const importTable = reactive({
    payload: [],
  });

  const resolveImportStatusLabel = (transaction_status) => {
    switch (transaction_status) {
      case STATUS_SUCCESS:
        return "Success";
      case STATUS_ERROR:
        return "Error";
      default:
        return "None";
    }
  };

  const resolveImportStatusClass = (transaction_status) => {
    switch (transaction_status) {
      case STATUS_SUCCESS:
        return "success";
      case STATUS_ERROR:
        return "error";
      default:
        return "None";
    }
  };

  const onClickDownload = (link) => {
    window.location.href = link;
  };

  const templateCSV =
    "https://devbcrmdata.blob.core.windows.net/bcrm-4-bl6zlw8pxbxa/AJAYT7XH1HMV_app-bo-cust/Fulfillment/20221216_172700_FFM_TrackingNo_G9RLXJ8.csv.csv";

  const fetchImportCSV = (file = null) => {
    if (!file) return;
    window.$loading(true);
    let payload = {
      uploadFile: file,
    };
    ImportCSV.payload = payload;
    store
      .dispatch("api/apiFormRequest", ImportCSV)
      .then((response) => {
        openSuccessModal(
          "ทำรายการสำเร็จ !",
          null,
          null,
          null,
          () => {
            fetchImportList();
          },
          () => {
            fetchImportList();
          }
        );
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const fetchImportList = () => {
    loading.tableData = true;
    fetchTableFulfillmentImportTrackingNoList.payload.Page =
      pagination.currentPage;
    fetchTableFulfillmentImportTrackingNoList.payload.Limit =
      pagination.perPage;
    fetchTableFulfillmentImportTrackingNoList.payload.Filters = filters;
    fetchTableFulfillmentImportTrackingNoList.payload.Ordering = ordering.value;
    store
      .dispatch("api/apiRequest", fetchTableFulfillmentImportTrackingNoList)
      .then((response) => {
        importTable.payload = response.data.resp.datalist.map((item) => ({
          seq: item.seq,
          importid: item.ffm_import_trackings.importid,
          bloburl: item.ffm_import_trackings.bloburl,
          created_by_identity_sref:
            item.ffm_import_trackings.created_by_identity_sref,
          createdtime: item.ffm_import_trackings.createdtime,
          updatedtime: item.ffm_import_trackings.updatedtime,
          reference: item.ffm_import_trackings.reference,
          total_trackingno: item.ffm_import_trackings.total_trackingno,
          total_success: item.ffm_import_trackings.total_success,
          total_error: item.ffm_import_trackings.total_error,
          transaction_status: item.ffm_import_trackings.transaction_status,
          transaction_statusdesc:
            item.ffm_import_trackings.transaction_statusdesc,
          name: item.name,
        }));
        pagination.rows = response.data.resp.datalist.length;
        pagination.totalRows = response.data.resp.filteredrecord;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchImportList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchImportList();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    fetchImportList();
  });

  const routeImportDetail = (importRef) => {
    router.push(`/fulfillment/import/detail/${importRef}`);
  };

  return {
    onClickDownload,
    fetchImportList,
    formStatus,
    fields,
    loading,
    importTable,
    statusOption,
    onSetValueSearch,
    routeImportDetail,
    resolveImportStatusLabel,
    resolveImportStatusClass,
    pagination,
    onPageChange,
    onFilterEntity,
    onSelectFilter,
    fetchImportCSV,
    templateCSV,
  };
}
